import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { ConfigContext } from "@pionex-web-kit/components";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useTranslators } from "../hooks/Locale";
import DataSubject from "./DataSubject";
import { ZendeskWidget } from "./ZendeskWidget";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ZendeskWidgetContext = /*#__PURE__*/createContext(false);
export var useZendeskWidgetReady = function useZendeskWidgetReady() {
  return useContext(ZendeskWidgetContext);
};
/**
 * zendesk widget (在线客服) 初始化，语言、主题设置
 */
export var ZendeskWidgetProvider = function ZendeskWidgetProvider(_ref) {
  var children = _ref.children,
    snippetKey = _ref.snippetKey,
    userId = _ref.userId,
    clientId = _ref.clientId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    widgetReady = _useState2[0],
    setWidgetReady = _useState2[1];
  var _useTranslators = useTranslators(),
    locale = _useTranslators.locale,
    $st = _useTranslators.$st;
  var _useContext = useContext(ConfigContext),
    theme = _useContext.theme;
  useEffect(function () {
    ZendeskWidget.reset();
  }, [theme]);
  useEffect(function () {
    if (window["zE"]) {
      setWidgetReady(true);
      return;
    }
    if (!snippetKey) {
      return;
    }
    var subscription = DataSubject.subscribe(function (type, data) {
      if (type === DataSubject.TYPE_ZENDESK_WIDGET_READY && data) {
        setWidgetReady(true);
      }
    });
    var scriptId = "ze-snippet";
    if (!document.getElementById(scriptId)) {
      var script = document.createElement("script");
      script.id = scriptId;
      script.type = "text/javascript";
      script.async = true;
      script.onload = function () {
        script.onload = null;
        if (!window["zE"]) {
          console.error("zendesk widget init error");
          return;
        } else {
          DataSubject.next(DataSubject.TYPE_ZENDESK_WIDGET_READY, true);
          ZendeskWidget.setWidgetReady(true);
        }
      };
      script.src = "https://static.zdassets.com/ekr/snippet.js?key=".concat(snippetKey);
      var head = document.getElementsByTagName("head")[0];
      head.appendChild(script);
    }
    return function () {
      return subscription.unsubscribe();
    };
  }, [snippetKey]);
  useEffect(function () {
    if (widgetReady) {
      ZendeskWidget.updateSettings({
        webWidget: {
          color: {
            theme: "rgb(var(--color-primary))"
          }
        }
      });
    }
  }, [widgetReady]);
  useEffect(function () {
    if (widgetReady) {
      ZendeskWidget.setLocale(locale);
    }
  }, [widgetReady, locale, $st]);
  useEffect(function () {
    ZendeskWidget.setLoginIn(!!userId);
  }, [userId]);
  useEffect(function () {
    ZendeskWidget.setClientId(clientId !== null && clientId !== void 0 ? clientId : "");
  }, [clientId]);
  return /*#__PURE__*/_jsxs(ZendeskWidgetContext.Provider, {
    value: widgetReady,
    children: [/*#__PURE__*/_jsx("style", {
      children: "iframe#launcher,div[role=presentation] > iframe {display: none !important;}"
    }), children]
  });
};